import { Chip, ChipSize, Icon } from "@outschool/backpack";
import { faCalendarExclamation } from "@outschool/icons";
import { useTranslation } from "@outschool/localization";
import { plural } from "@outschool/text";
import React from "react";

interface RemainingMeetingsChipProps {
  numRemainingMeetings: number;
  size?: ChipSize;
}

export const RemainingMeetingsChip: React.FunctionComponent<
  RemainingMeetingsChipProps
> = ({ numRemainingMeetings, size }) => {
  const { t } = useTranslation(
    "client\\components\\Chips\\RemainingMeetingsChip"
  );
  return (
    <Chip
      label={t("{{numRemainingMeetings}} {{sessionsLabel}} left", {
        numRemainingMeetings,
        sessionsLabel: plural("session", numRemainingMeetings)
      })}
      size={size}
      color="warning"
      icon={<Icon icon={faCalendarExclamation} />}
    />
  );
};
